<div class="container mb-5">
  <div class="container text-center">
    <h4 style="color: var(--secondary-color)" class="display-5 ">Cuéntanos tu <span class="fw-bold"> Experiencia</span></h4>
  </div>

  <div class="container mt-5 w-75">
    <form [formGroup]="createPQRS" (ngSubmit)="validatePQRS()">
      <div class=" mb-3">
        <label style="color: var(--primary-color)" for="nrDocumento" class="form-label">Número de documento</label>
        <input formControlName="identificacion" (blur)="validateCedulaFormPqrs()" type="text" class="form-control" id="nrDocumento" placeholder="">

      </div>
      <div class="mb-3">
        <label style="color: var(--primary-color)" for="nameUsuario" class="form-label">Nombre</label>
        <input formControlName="name" type="text" class="form-control" id="nameUsuario" placeholder="">
      </div>
      <div class=" mb-3">
        <label style="color: var(--primary-color)" for="apellidoUsuario" class="form-label">Apellido</label>
        <input formControlName="surname" type="text" class="form-control" id="apellidoUsuario" placeholder="">
      </div>
      <div class="row mb-3">
        <div class="col-6">
          <label style="color: var(--primary-color)" for="emailUsuario" class="form-label">Email</label>
          <input formControlName="email" type="email" class="form-control" id="emailUsuario" placeholder="">
        </div>
        <div class="col-6">
          <label style="color: var(--primary-color)" for="celularUsuario" class="form-label">Número de celular</label>
          <input formControlName="phone" type="text" class="form-control" id="celularUsuario" placeholder="">
        </div>
      </div>
      <div class=" mb-3">
        <label style="color: var(--primary-color)" for="mensajeUsuario" class="form-label">Mensaje</label>
        <textarea formControlName="message" type="text" class="form-control" id="mensajeUsuario" placeholder=""></textarea>
      </div>
      <p style="font-size: 13px" class="text-secondary">Al continuar estás aceptando nuestras <a routerLink="/politica-privacidad">politicas
        de uso y tratamiento de información personal</a></p>

      <div class="container text-center">
        <button class="">Envíar</button>
      </div>


    </form>
  </div>
</div>


<app-notifications/>
